import React from 'react'
import type { IconProps } from '@strata-monorepo/shared-ui/types/Svg'

const ArrowLeftIcon = ({ classNames, ...props }: IconProps): React.ReactElement => (
  <svg
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    className={classNames}
    {...props}
  >
    <path
      d='M4.19948 6.66251L5.36305 7.82609C5.49132 7.95435 5.55454 8.10869 5.55273 8.28912C5.55092 8.46957 5.48769 8.62392 5.36305 8.75217C5.23479 8.88044 5.07954 8.94548 4.89729 8.94729C4.71504 8.9491 4.55978 8.88588 4.43152 8.75761L2.13695 6.47011C2.00398 6.33714 1.9375 6.18043 1.9375 6C1.9375 5.81957 2.00398 5.66286 2.13695 5.52989L4.43152 3.24239C4.55978 3.11412 4.71504 3.05089 4.89729 3.05271C5.07954 3.05452 5.23479 3.11956 5.36305 3.24782C5.48769 3.37608 5.55092 3.53043 5.55273 3.71087C5.55454 3.89131 5.49132 4.04565 5.36305 4.17391L4.19948 5.33749H9.4C9.58406 5.33749 9.74049 5.40189 9.8693 5.5307C9.99811 5.65951 10.0625 5.81594 10.0625 6C10.0625 6.18406 9.99811 6.34049 9.8693 6.4693C9.74049 6.59811 9.58406 6.66251 9.4 6.66251H4.19948Z'
      fill='currentColor'
    />
  </svg>
)

export default ArrowLeftIcon
